export const submitStripePaymentForm = (paymentMethod) => (dispatch, getState) => {
	const { stripeSubmitHandle } = getState().paymentProcessors[paymentMethod.name];
	return new Promise((resolve, reject) => {
		stripeSubmitHandle()
			.then(result => {
				const submitError = result.error;
				if (submitError) {
					reject(submitError.message);
				} else {
					resolve();
				}
			});
	});
};

export const confirmStripePayment = (paymentMethod, clientAuthorizationToken, returnUrl) => (dispatch, getState) => {
	const { stripePaymentHandle } = getState().paymentProcessors[paymentMethod.name];
	return new Promise((resolve, reject) => {
		stripePaymentHandle(clientAuthorizationToken, returnUrl)
			.then(result => {
				if (result.error) {
					reject(result.error);
				} else {
					resolve(result.paymentIntent);
				}
			});
	});
};